import { commonStore } from 'common/store/common'
import { dashboardStore } from 'public/store/dashboard'
import { residentServiceApplicationTypesStore } from 'public/store/resident_service_application_types'

export default {
  modules: {
    common: { namespaced: true, ...commonStore },
    dashboard: { namespaced: true, ...dashboardStore },
    residentServiceApplicationTypes: { namespaced: true, ...residentServiceApplicationTypesStore }
  }
}
